import { Link } from 'react-router-dom';
import '../style.css';
import { IOrdersProps, IPurchase } from '../types';

const Header = ({ orders }: IOrdersProps) => {
  const ordersStorage = JSON.parse(localStorage.getItem('orders') || '[]');
  let totalPrice: number;
  if (ordersStorage) {
    totalPrice = ordersStorage.reduce(
      (sum: number, el: IPurchase) => (sum += el.price),
      0
    );
  } else {
    totalPrice = totalPrice = orders.reduce(
      (sum: number, el: IPurchase) => (sum += el.price),
      0
    );
  }
  return (
    <div className="header-container">
      <div className="header-h1">
        <Link to="/" title="Logo">
          <h1>Online store</h1>
        </Link>
      </div>
      <div
        style={{
          color: 'rgb(129, 49, 49)',
          fontWeight: 'bold',
          fontSize: '18px',
        }}
      >
        {'Total price: $' + totalPrice.toFixed(2)}
      </div>

      <div className="right-part-header">
        <div className="button-basket">
          <Link to="/basket">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="30"
              fill="currentColor"
              className="bi bi-basket"
              viewBox="0 0 16 16"
            >
              <path d="M5.757 1.071a.5.5 0 0 1 .172.686L3.383 6h9.234L10.07 1.757a.5.5 0 1 1 .858-.514L13.783 6H15a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1v4.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 13.5V9a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h1.217L5.07 1.243a.5.5 0 0 1 .686-.172zM2 9v4.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V9H2zM1 7v1h14V7H1zm3 3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3A.5.5 0 0 1 4 10zm2 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3A.5.5 0 0 1 6 10zm2 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3A.5.5 0 0 1 8 10zm2 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 .5-.5zm2 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 .5-.5z" />
            </svg>
            <span
              style={{
                color: 'rgb(129, 49, 49)',
                fontWeight: 'bold',
                fontSize: '18px',
              }}
            >
              {' '}
              {ordersStorage.length}{' '}
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Header;
